// extracted by mini-css-extract-plugin
export default {"messageTime":"ChatMessageTime_messageTime__JXBFu"};